import AIducatorsRedesign from './AIducators';

function App() {
  return <AIducatorsRedesign />;
}

export default App;
